import classNames from 'classnames';
import { IconArrowRight2 } from '@/features/icons';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
interface Props {
  direction?: 'left' | 'right';
  onClick?: (e: React.MouseEvent) => void;
}
export default function Arrow({
  direction,
  onClick
}: Props) {
  return <span role='button' onClick={onClick} aria-label={direction === 'left' ? 'prev' : 'next'} className={classNames('cursor-pointer rounded-md bg-surface-scrim-white p-1 text-text-black')} data-sentry-component="Arrow" data-sentry-source-file="arrow.tsx">
            {direction === 'left' ? <IconArrowSquareLeft className='h-6 w-6' /> : <IconArrowRight2 className='h-6 w-6' />}
        </span>;
}